/**
 * Diagnoses API
 * Manages the global diagnoses list (shared across all patients)
 */

import { apiClient } from './config';

export const fetchDiagnoses = async () => {
  const response = await apiClient.get('/get-diagnoses');
  return response.data;
};

export const addDiagnosis = async (name) => {
  const response = await apiClient.post('/add-diagnosis', { name });
  return response.data;
};

export const deleteDiagnosis = async (diagnosisId) => {
  const response = await apiClient.delete(`/delete-diagnosis/${diagnosisId}`);
  return response.data;
};
